module.exports = __webpack_public_path__ + "static/assets/7be7668a6cb89d0757e53b879d209b1c.jpg";